import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Grid, Table, Header, Checkbox, Icon } from 'semantic-ui-react';

import { LoadingBar } from 'components/Commons';
import { Popup } from 'semantic-ui-react';
import ReactTable from 'react-table';
import Infinite from 'react-infinite';
import scroll from 'helpers/scroll';
import cm from 'helpers/commons';
import storage from 'helpers/storage';

class MealApproveResult extends Component {
  constructor(props) {
    super(props);
    this.state = {
      elements: [],
      heightIdx: 0,
      containerHeight: 620,
      headers: [
        { header: '', width: 56, isChecked: true },
        { header: '#', width: 48 },
        { header: '상태', width: 76 },
        { header: '신청시간', width: 144 },
        { header: '지급시간', width: 144 },
        { header: 'ID', width: 120 },
        { header: '이름', width: 116 },
        { header: '식대그룹', width: 128 },
        { header: '식대정책', width: 128 },
        { header: '식대', width: 88 },
        { header: '신청사유', width: 144 },
        { header: '결재', width: 144 },
        { header: '반려자', width: 116 },
        { header: '반려사유', width: 144 }
      ]
    };
  }

  componentWillMount() {
    const { list } = this.props;
    this.scrollEvent(list);
  }

  componentWillReceiveProps(nextProps) {
    const { list } = nextProps;

    this.scrollEvent(list);
  }

  scrollEvent = (list) => {
    if (list && list.data.demand.length > 0) {
      const { demand } = list.data;
      this.setState({
        elements: this.buildElements(0, 100, demand)
      });
    } else {
      this.setState({ elements: [] });
    }
  };

  handleInfiniteLoad = () => {
    const { list, resultFn } = this.props;
    const { elements, heightIdx, containerHeight } = this.state;
    const item = list ? list.data.demand : null;

    let that = this;
    let elemLength = elements.length;
    let itemLength = item ? item.length : 0;
    const infiniteParm = scroll.event(item, elements, containerHeight, heightIdx, elemLength);

    if (elemLength < itemLength) {
      let data = this.buildElements(elemLength, elemLength + 100, item);
      this.setState({
        isInfiniteLoading: true,
        heightIdx: heightIdx + containerHeight
      });
      setTimeout(() => {
        that.setState({
          elements: that.state.elements.concat(data),
          heightIdx: infiniteParm.heightIdx,
          isInfiniteLoading: false
        });
      }, 500);
    } else {
      this.setState({
        isInfiniteLoading: false
      });
    }
  };

  elementInfiniteLoad = () => {
    return <LoadingBar style={{ height: '800px' }} />;
  };

  listItem = (item) => {
    const { resultFn } = this.props;
    const { headers } = this.state;
    let result = null;

    if (item) {
      const division = cm.trTdDivision(item.user.orgCode);
      let styles = [];
      headers.forEach((headerItem, index) => {
        styles.push({
          flex: `${headerItem.width} 0 auto`,
          width: headerItem.width,
          maxWidth: headerItem.width,
          padding: '10px 0'
        });
      });

      let registDate = '-',
        acceptDate = '-',
        personInCharge = '',
        rejectName = '',
        rejectCause = '';

      if (item.date) {
        registDate = cm.yyyyMMdd(new Date(item.date.regist)) + ' ' + cm.hhmmss(new Date(item.date.regist));

        if (['READY', 'CANCEL', 'REJECT', 'NONE'].indexOf(item.status.value) === -1) {
          acceptDate = item.date.accept
            ? cm.yyyyMMdd(new Date(item.date.accept)) + ' ' + cm.hhmmss(new Date(item.date.accept))
            : '-';
        }
      }

      if (item.confirm) {
        personInCharge = item.confirm
          .map((person) => {
            return person.name;
          })
          .join(' > ');
      }

      if (item.reject) {
        rejectName = item.reject.name;
        rejectCause = item.reject.cause;
      }

      let isDisabled = item.status.value !== 'READY' ? true : false;

      result = (
        <div className="rt-tr -odd" key={item.id}>
          <div className="rt-td" style={styles[0]}>
            <div className="checkbox pure">
              <label>
                <input
                  type="checkbox"
                  id={item.id}
                  name={item.user.name}
                  disabled={isDisabled}
                  className={`staff-checkbox ${item.signid}`}
                  value="on"
                  onClick={(e) => resultFn.selectEach()}
                />
                <span></span>
              </label>
            </div>
          </div>
          <div className="rt-td" style={styles[1]}>
            {item.idx}
          </div>
          <div className="rt-td" style={styles[2]}>
            {item.status.text}
          </div>
          <div className="rt-td" style={styles[3]}>
            {registDate}
          </div>
          <div className="rt-td" style={styles[4]}>
            {acceptDate}
          </div>
          <div className="rt-td" style={styles[5]}>
            {item.user.signid}
          </div>
          <div className="rt-td" style={styles[6]}>
            {item.user.name}
          </div>
          {division.map((divi, i) => {
            return (
              <div
                key={`divi${i}`}
                className="rt-td"
                style={{ flex: `128 0 auto`, width: 128, maxWidth: 128, padding: '10px 0' }}
              >
                <Popup className="td-tooltip" inverted trigger={<span>{divi}</span>} content={divi} />
              </div>
            );
          })}
          <div className="rt-td" style={styles[7]}>
            {item.group.name}
          </div>
          <div className="rt-td" style={styles[8]}>
            {item.policy.name}
          </div>
          <div className="rt-td" style={styles[9]}>
            {cm.numberComma(item.amount)}
          </div>
          <div className="rt-td" style={styles[10]}>
            <Popup className="td-tooltip" inverted trigger={<span>{item.cause}</span>} content={item.cause} />
          </div>
          <div className="rt-td" style={styles[11]}>
            {personInCharge}
          </div>
          <div className="rt-td" style={styles[12]}>
            {rejectName}
          </div>
          <div className="rt-td" style={styles[13]}>
            <Popup className="td-tooltip" inverted trigger={<span>{rejectCause}</span>} content={rejectCause} />
          </div>
        </div>
      );

      return result;
    } else {
      return null;
    }
  };

  buildElements = (st, en, item) => {
    let elements = [];
    // if(!item) {
    //   return elements;
    // }
    for (let i = st; i < en; i++) {
      const temp = this.listItem(item[i]);
      if (temp) {
        elements.push(temp);
      }
    }
    return elements;
  };

  tBodyFunc = (state) => {
    const { elements, containerHeight, isInfiniteLoading } = this.state;
    return (
      <div className="rt-tbody" style={state.style}>
        <div className="rt-tr-group">
          <Infinite
            className="infinite-scroll"
            elementHeight={40}
            containerHeight={containerHeight}
            infiniteLoadBeginEdgeOffset={containerHeight - 50}
            onInfiniteLoad={this.handleInfiniteLoad}
            loadingSpinnerDelegate={this.elementInfiniteLoad()}
            isInfiniteLoading={isInfiniteLoading}
            // handleScroll={this.scrollHandler}
          >
            {elements}
          </Infinite>
        </div>
      </div>
    );
  };

  noDataProps = (state) => {
    const { list } = this.props;
    let dom = <div className="rt-noData">검색 결과가 없습니다.</div>;
    if (list && list.data.demand.length > 0) {
      dom = <div className="rt-noData"></div>;
    }

    return dom;
  };

  render() {
    const { list, selectAll } = this.props.resultFn;
    let approvalList = '',
      loading;

    const { elements, isInfiniteLoading, heightIdx, containerHeight, headers } = this.state;

    let header = cm.tableHeaderList(headers, 7);

    const fn = {
      fnChecked: selectAll,
      move: null
    };

    // let depth = storage.get("depth");
    // let tooltipArray = cm.tooltipHeader(8, [10, 13]);
    const columns = scroll.header(header, fn);
    return (
      <div>
        {loading}

        <ReactTable
          className="react-table"
          noDataText={'검색 결과가 없습니다.'}
          columns={columns}
          sortable={false}
          resizable={false}
          showPagination={false}
          loading={isInfiniteLoading}
          TbodyComponent={this.tBodyFunc}
          NoDataComponent={this.noDataProps}
        />
      </div>
    );
  }
}

MealApproveResult = connect(
  (state) => ({
    list: state.sikdae.mealList
  }),
  (dispatch) => ({})
)(MealApproveResult);

export default MealApproveResult;
